<template>
    <div>
        <el-dialog
            title="经纪人详情"
            :visible.sync="showDialog"
            width="800px"
            @close="close">
            <div class="base-warp">
                <el-row class="project-detail">
                    <el-col class="project" :span="24" :offset="0">
                        <el-row class="prow">
                            <el-col :span="24" :offset="0">
                                <div class="label">
                                    姓名
                                </div>
                                <div class="info">
                                    <span class="span" >{{borker.name}}</span>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row class="prow">
                            <el-col :span="24" :offset="0">
                                <div class="label">
                                    电话
                                </div>
                                <div class="info">
                                    <span class="span" >{{borker.telephone}}</span>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row class="prow">
                            <el-col :span="24" :offset="0">
                                <div class="label">
                                    身份证
                                </div>
                                <div class="info">
                                    <span class="span" >{{borker.idcard}}</span>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row class="prow">
                            <el-col :span="24" :offset="0">
                                <div class="label">
                                    营业执照
                                </div>
                                <div class="info" v-if="borker.businessLicense">
                                    <div class="img-warp">
                                        <div class="img-box" v-for="(img, index) in borker.businessLicense" :key="index">
                                            <el-image class="img" :src="img" fit="contain" :lazy="true" :preview-src-list="borker.businessLicense"></el-image>
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row class="prow">
                            <el-col :span="24" :offset="0">
                                <div class="label">
                                    工作证
                                </div>
                                <div class="info" v-if="borker.workPermit">
                                    <div class="img-warp">
                                        <div class="img-box" v-for="(img, index) in borker.workPermit" :key="index">
                                            <el-image class="img" :src="img" fit="contain" :lazy="true" :preview-src-list="borker.workPermit"></el-image>
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row class="prow">
                            <el-col :span="24" :offset="0">
                                <div class="label">
                                    头像
                                </div>
                                <div class="info" v-if="borker.ltpic">
                                    <div class="img-warp">
                                        <div class="img-box" v-for="(img, index) in borker.ltpic" :key="index">
                                            <el-image class="img" :src="img" fit="contain" :lazy="true" :preview-src-list="borker.ltpic"></el-image>
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row >
                <el-row>
                    <div class="foot">
                        <el-button v-if="borker.status=='01'" type="danger" size="default" @click="shownopass = true">不通过</el-button>
                        <el-button v-if="borker.status=='01'" type="primary" size="default" @click="pass">审核通过</el-button>
                    </div>
                </el-row>
            </div>

            <el-dialog
            width="400px"
            title="不通过理由"
            :visible.sync="shownopass"
            append-to-body>
                <el-form :model="form" ref="form" label-width="80px" :inline="false" size="normal">
                    <el-form-item label="填写理由">
                        <el-input type="textarea" v-model="form.marker"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="nopass">提交不通过</el-button>
                        <el-button @click="shownopass = false">取消</el-button>
                    </el-form-item>
                </el-form>
                
            </el-dialog>
        </el-dialog>
        
    </div>
</template>

<script>
export default {
    data() {
        return {
            showDialog: true,
            borker: '',
            shownopass: false,
            form: {
                marker: '',
            },
        }
    },
    mounted () {
        var item = this.$route.query.item;
        var items = JSON.parse(item);
        if(items.businessLicense) items.businessLicense = JSON.parse(items.businessLicense);
        if(items.workPermit) items.workPermit = JSON.parse(items.workPermit);
        if(items.ltpic) items.ltpic = JSON.parse(items.ltpic);
        this.borker = items;
    },
    methods: {
        close() {
            this.$router.go(-1);
        },
        pass() {
            this.$confirm('是否确定通过审核').then(
                confirm=>{
                    var params = {
                        id: this.borker._id['$oid']
                    }
                    this.$api.borkerPass(params).then(
                        data=>{
                            this.$message.success(data);
                            this.borker.status = '03';
                        }
                    )
                },
                cancel=>{}
            )
        },
        nopass() {
            var params = {
                id: this.borker._id['$oid'],
                marker: this.form.marker,
            }
            this.$api.borkerNoPass(params).then(
                data=>{
                    this.message.success(data);
                    this.borker.status = '04';
                }
            )
        },
    },
}
</script>

<style lang="scss" scoped>

</style>